import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

Partner4.propTypes = {
    data: PropTypes.array,
    className: PropTypes.string, // Agrega className a las PropTypes
};

function Partner4(props) {
    const { data, className } = props; // Desestructura className de props
    return (
        <section className={`tf-section tf_partner ${className}`}> {/* Usa className aquí */}
            <div className="overlay">
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title mt-5">
                                Confían en nosotros
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-12 mb-5">
                        <div className="partner-wrapper style1 gap-4" data-aos="fade-up" data-aos-duration="800">
                            {
                                data.map(item => (
                                    <Link key={item.id} to="/" className="image">
                                        <img src={item.src} alt={item.alt} />
                                    </Link>
                                ))
                            }

                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Partner4;